import { render, staticRenderFns } from "./join-form.vue?vue&type=template&id=3106931d"
import script from "./join-form.vue?vue&type=script&lang=js"
export * from "./join-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports